import * as React from 'react';

import { useDetectPrint } from 'lib/use-detect-print';

import Accordion from 'components/accordion/accordion';
import { Card } from 'components/card';
import Cards from 'components/cards/cards';
import { Columns, ColumnsItem } from 'components/columns';
import { ColumnsSize } from 'components/columns/columns-item';
import { CtaBox, CtaBoxHeader, CtaBoxText } from 'components/cta-box';
import GoodToKnow from 'components/good-to-know/good-to-know';
import PageSection from 'components/page/page-section';
import { SectionContentLinkListIdFive } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { TitleAnchorContent } from 'components/title-anchor/title-anchor-content';
import { Header2, Header3, P1, P2 } from 'components/typography';

import { getPropsSectionFiveContainer } from './section-five-container.props';
export const SectionFiveContainer: React.FC = () => {
  const props = getPropsSectionFiveContainer();
  const isPrinting = useDetectPrint();
  return (
    <>
      <PageSection inner={true}>
        <CtaBox align="start">
          <CtaBoxHeader>
            <Header3 as="p">{props.sections.one.intro}</Header3>
          </CtaBoxHeader>
        </CtaBox>
      </PageSection>
      <PageSection padding="block" inner={true} extraClass="page-section--cards-filled-primary">
        <Columns hasMobileLayout={true}>
          <ColumnsItem verticalAlign="stretch" size={ColumnsSize['1/1']}>
            <Cards>
              {props.sections.one.cards.map((card, index) =>
                isPrinting ? (
                  <React.Fragment key={index}>
                    <P1>
                      <b>{card.title}</b>
                    </P1>
                    <P2 html={card.content} as="p" />
                  </React.Fragment>
                ) : (
                  <Card
                    key={`card-rights-${index}`}
                    title={
                      <P1>
                        <b>{card.title}</b>
                      </P1>
                    }
                    text={<P2 html={card.content} as="p" />}
                    imageSrc={card.imageSrc}
                    styling="filled"
                  />
                ),
              )}
            </Cards>
          </ColumnsItem>
        </Columns>
      </PageSection>
      <PageSection color="orange" extraClass="section-cta" padding="block" inner={true}>
        <Columns hasMobileLayout={true}>
          <ColumnsItem verticalAlign="stretch" size={ColumnsSize['1/2']}>
            <div className="speech-box-list">
              {props.sections.two.chat.map((chatMessage, index) => (
                <div className="speech-box-list__item" key={`chat-message--${index}`}>
                  {
                    <div
                      className={`speech-box speech-box--relatively-full-width speech-box--chat ${index % 2 ? 'speech-box--soft-white' : 'speech-box--soft-yellow speech-box--no-margin speech-box--even'}`}
                    >
                      <P1 html={chatMessage} as="p" />
                    </div>
                  }
                </div>
              ))}
              <div className="speech-box-list__item--large-gap">{props.sections.two.text}</div>
            </div>
          </ColumnsItem>
          <ColumnsItem size={ColumnsSize['1/2']}>
            <TitleAnchorContent
              content={
                <GoodToKnow
                  title={props.sections.two.goodToKnow.title}
                  content={props.sections.two.goodToKnow.content}
                />
              }
              id={SectionContentLinkListIdFive.HowDoYouEnforceYourRights}
            />
          </ColumnsItem>
        </Columns>
      </PageSection>
      <PageSection color="peach" extraClass="section-cta" padding="block" inner={true}>
        <CtaBox align="center">
          <CtaBoxHeader tag="h2">
            <Header2>
              <TitleAnchor
                title={props.sections.three.title}
                titleAnchorElement={TitleAnchor.ElementType.NONE}
                id={SectionContentLinkListIdFive.DoYouLiveInCalifornia}
              />
            </Header2>
          </CtaBoxHeader>
          <CtaBoxText>
            <div
              style={{
                margin: '0 auto',
                width: '100%',
                maxWidth: 720,
              }}
            >
              {props.sections.three.subtitle}
            </div>
          </CtaBoxText>
        </CtaBox>
      </PageSection>
      <PageSection color="peach" extraClass="section-cta" padding="bottom" inner={true}>
        <div className="accordion-container">
          {props.sections.three.accordion.map((item, key) => (
            <Accordion key={`rights-${key}`} title={item.title} content={item.content} />
          ))}
        </div>
      </PageSection>
    </>
  );
};
